import Vue from 'vue';
import AjaxUtils from "../../util/ajax_utils";
import VueApexCharts from "vue-apexcharts";

import { ApckWidgetCounter } from './widgets/counter';
import { ApckModalPortletSettings } from './portal';

export const ApckPortlet = /*#__PURE__*/ Vue.extend({
    props: {
        portal: {
            type: Object,
            default: null
        },
        ctype: {
            type: String,
            default: null
        },
        title: {
            type: String,
            default: ""
        },
        size: {
            type: String,
            default: "md"
        },
        collapsed: {
            type: Boolean,
            default: false
        },
        hideMenu: {
            type: Boolean,
            default: false
        },
        description: {
            type: String,
            default: null
        },
        src: {
            type: String,
            default: null
        },
        start_date: {
            type: String,
            default: null
        },
        end_date: {
            type: String,
            default: null
        },
    },
    data: function() {
        return {
            options: {
                title: {
                    type: "string",
                    default: "",
                    label: "Title"
                },
                size: {
                    type: "select",
                    default: "md",
                    label: "Size",
                    choices: [
                        {"label": "Small", "value": "sm"},
                        {"label": "Medium", "value": "md"},
                        {"label": "large", "value": "lg"},
                        //{"label": "Full width", "value": "full"},
                    ]
                },
            },
        }
    },
    created() {
        if (this.portal) {
            this.portal.$data.portletComponents[this.$attrs.index] = this;
        }
        for (const key of Object.keys(this.options)) {
            if (!("value" in this.options[key])) {
                // try to find value in $attrs or $props
                const value = key in this.$attrs ? this.$attrs[key] : this.$props[key];
                this.$set(this.options[key], "value", (value || value === 0) ? value : this.options[key].default);
            }
        }
    },
    mounted: function () {
        this.options.title.value = this.title;
        this.options.size.value = this.size.toLowerCase();
        this.refresh();
    },
    methods: {
        refresh: function () {},
        remove: function () {
            const cmp = this;
            cmp.$dialog.confirm(
                'Are you sure you want to delete this portlet?',
                'Delete Portlet',
                function () {
                    cmp.portal.deletePortlet(cmp.$attrs.index);
                }
            );
        },
        settings: function () {
            this.$lightbox.open({
                component: ApckModalPortletSettings,
                bind: {
                    portal: this.portal,
                    availablePortlets: this.portal.$props.availablePortlets,
                    _selectedPortlet: this,
                },
                size: "wide",
            })
        },
        getConfig: function () {
            const config = {"ctype": this.ctype, "collapsed": false};
            for (const key of Object.keys(this.options)) {
                config[key] = this.options[key].value;
            }
            return config;
        },
        collapse() {
            this.collapsed = !this.collapsed;
        }
    },
    computed: {
        colSize: function() {
            const size = this.options.size.value;
            if (size === 'sm') {
                return 'col-33';
            } else if (size === 'md') {
                return 'col-66';
            } else if (size === 'lg') {
                return 'col-100';
            } else if (size === 'full') {
                return 'col-100';
            }
        },
        computedURL: function() {
            if (!this.src) {
                return null;
            }
            let url = this.src;
            if (this.portal && this.portal.portletBaseUrl) {
                url = this.portal.portletBaseUrl + this.src;
            }

            const params = new URLSearchParams();
            for (const key of Object.keys(this.options)) {
                if (key === "title" || key === "size") {
                    // we don't need to pass the title or size options
                    continue;
                }
                const value = this.options[key].value;
                if (value !== null && value !== undefined) {
                    params.set(key, value);
                }
            }
            if (this.start_date) {
                params.set('start_date', this.start_date);
            }
            if (this.end_date) {
                params.set('end_date', this.end_date);
            }
            return `${url}?${params.toString()}`;
        },
    },
    template: `
        <div :class="'portlet no-min-height col droppable draggable ' + colSize">
            <apck-panel no-padding :title="title" force-menu :draggable="Boolean(portal)">
                <template v-slot:menu="" v-if="portal && !hideMenu">
                    <apck-button
                        icon="fa-regular fa-gear"
                        :handler="settings"
                        class="title-button"
                        title="Settings"
                    />
                    <apck-button
                        icon="fa-regular fa-refresh"
                        :handler="refresh"
                        class="title-button"
                        title="Refresh"
                    />
                    <apck-button
                        :icon="['fa-regular', collapsed ? 'fa-chevron-down' : 'fa-chevron-up'].join(' ')"
                        :handler="collapse"
                        class="title-button"
                        :title="collapsed ? 'expand' : 'collapse'"
                    />
                    <apck-button
                        icon="fa-regular fa-close"
                        :handler="remove"
                        class="title-button"
                        title="Delete"
                    />
                </template>
            </apck-panel>
        </div>
    `
});

export const ApckSimplePortlet = /*#__PURE__*/ Vue.extend({
    props: {
        title: {
            type: String,
            default: null
        }
    },
    data: function() {
        return {};
    },
    template: `
        <div class="portlet no-min-height col droppable draggable">
            <apck-panel no-padding :title="title" draggable force-menu>
                <template v-slot:menu="data">
                    <slot name="menu" v-bind="data" />
                </template>
                <slot />
            </apck-panel>
        </div>
    `
});

export const ApckPortletCardPanel =  /*#__PURE__*/ ApckPortlet.extend({
    components: {
        'apck-widget-counter': ApckWidgetCounter
    },
    data: function() {
        return {
            cards: [],
            total: 0,
            loading: false
        };
    },
    methods: {
        fetchSrc: function () {
            var cmp = this;
            var url = cmp.computedURL;
            this.loading = true;
            AjaxUtils.ajax_get({
                url: url,
                success: function (data) {
                    if (data) {
                        cmp.cards = data['cards'];
                        cmp.total = data['total'];
                    } else {

                    }
                    cmp.loading = false;
                },
                fail: function () {
                    cmp.loading = false;
                },
                opts: {
                    dataType: 'json',
                    flash_form_errors: false,
                    flash_404_errors: false
                }
            });
        },
        refresh: function() {
            if (this.src) {
                this.loading = true;
                this.fetchSrc();
            }
        }
    },
    template: `
        <div :class="'portlet no-min-height col droppable draggable new-ui ' + colSize">
            <apck-panel :title="title" force-menu :draggable="portal && !hideMenu">
                <template v-slot:menu v-if="portal && !hideMenu">
                    <apck-button
                        icon="fa-regular fa-gear"
                        :handler="settings"
                        class="title-button"
                        title="Settings"
                    />
                    <apck-button
                        icon="fa-regular fa-refresh"
                        :handler="refresh"
                        class="title-button"
                        title="Refresh"
                    />
                    <apck-button
                        :icon="['fa-regular', collapsed ? 'fa-chevron-down' : 'fa-chevron-up'].join(' ')"
                        :handler="collapse"
                        class="title-button"
                        :title="collapsed ? 'expand' : 'collapse'"
                    />
                    <apck-button
                        icon="fa-regular fa-close"
                        :handler="remove"
                        class="title-button"
                        title="Delete"
                    />
                </template>
                
                <div class="portlet-card-panel" v-if="!collapsed">
                    <div v-for="card in cards" class="flex-column">
                        <apck-widget-counter
                            v-if="card.type === 'counter'"
                            :title="card.title"
                            :data="card.data"
                            :icon="card.icon"
                            :icon-class="card.iconClass" 
                            :counter-class="card.counterClass"
                            :background-class="card.backgroundClass"
                            :no-border="!!card.noBorder"
                            :action-url="card.actionUrl"
                        />
                    </div>
    
                    <div v-if="cards.total == 0" class="flex-column">
                        <h2>
                            Cards are unconfigured or could not be fetched.
                        </h2>
                    </div>
                </div>

                <ui-spinner :show="loading" theme="dark" />
            </apck-panel>
        </div>
    `
});

export const ApckPortletTable = /*#__PURE__*/ ApckPortlet.extend({
    props: {
        cols: {
            type: Array,
            default: () => [],
        },
        showToolbar: {
            type: Boolean,
            default: false,
        },
        showPageBar: {
            type: Boolean,
            default: false,
        },
        rowAction: {
            type: Function,
        },
        sglRowAction: {
            type: Function,
        },
        rowLink: {
            type: Function,
        },
        limit: {
            type: Number,
            default: 10
        },
        tableOptions: {
            type: Object,
            default: function () {
                return {};
            }
        },
    },
    data: function () {
        return {
            table_actions: null,
        }
    },
    methods: {
        refresh: function() {
            // empty overide method to stop table refreshing twice on update
        },
        manual_refresh: function() {
            if (this.src) {
                this.$refs.table.store.reload();
            }
        }
    },
    template: `
        <div :class="'portlet no-min-height col droppable draggable ' + colSize">
            <apck-panel no-padding :title="title" force-menu :draggable="Boolean(portal)">
                <template v-slot:menu="" v-if="portal && !hideMenu">
                    <apck-button
                        icon="fa-regular fa-gear"
                        :handler="settings"
                        class="title-button"
                        title="Settings"
                    />
                    <apck-button
                        icon="fa-regular fa-refresh"
                        :handler="manual_refresh"
                        class="title-button"
                        title="Refresh"
                    />
                    <apck-button
                        :icon="['fa-regular', collapsed ? 'fa-chevron-down' : 'fa-chevron-up'].join(' ')"
                        :handler="collapse"
                        class="title-button"
                        :title="collapsed ? 'expand' : 'collapse'"
                    />
                    <apck-button
                        icon="fa-regular fa-close"
                        :handler="remove"
                        class="title-button"
                        title="Delete"
                    />
                </template>
                    
                <apck-table
                    v-if="!collapsed"
                    ref="table"
                    :columns="cols"
                    :src="this.computedURL"
                    :showToolbar="showToolbar"
                    :showPageBar="showPageBar"
                    :row-action="rowAction"
                    :sgl-row-action="sglRowAction"
                    :row-link="rowLink"
                    :actions="table_actions"
                    :limit="limit"
                    v-bind="tableOptions"
                    :newStyleTable="true"
                />
            </apck-panel>
        </div>
    `
});


export const ApckPortletApexChart = /*#__PURE__*/ ApckPortlet.extend({
    components: {
        'apexchart': VueApexCharts,
    },
    props: {
        chartType: {
            type: String,
            default: 'line',
        },
        chartHeight: {
            type: [Number, String],
            default: "100%",
        },
        defaultChartOptions: {
            type: Object,
            default: function () {
                return {};
            }
        },
        defaultChartSeries: {
            type: Array,
            default: function () {
                return [];
            }
        },
    },
    data: function() {
        return {
            series: null,
            loading: false,
            chartOptions: this.defaultChartOptions,
            chartSeries: this.defaultChartSeries,
        };
    },
    watch: {
        computedURL: {
            handler: function() {
                this.refresh();
            }
        }
    },
    methods: {
        fetchSrc: function () {
            var cmp = this;
            var url = this.computedURL;
            if (url) {
                this.loading = true;
                AjaxUtils.ajax_get({
                    url: url,
                    success: function (data) {
                        cmp.parseData(data);
                        cmp.loading = false;
                    },
                    fail: function () {
                        cmp.loading = false;
                    },
                    opts: {
                        dataType: 'json',
                        flash_form_errors: false,
                        flash_404_errors: false
                    }
                });
            }
        },
        parseData: function (data) {
            console.log(data);
        },
        refresh: function() {
            if (this.src) {
                this.loading = true;
                this.fetchSrc();
            }
        },
        reloadChart: function() {
            this.$refs.portletChart.refresh();
        }
    },
    template: `
        <div :class="'portlet no-min-height col droppable draggable ' + colSize">
            <apck-panel no-padding :title="title" force-menu :draggable="Boolean(portal)">
                <template v-slot:menu="" v-if="portal && !hideMenu">
                    <apck-button
                        icon="fa-regular fa-gear"
                        :handler="settings"
                        class="title-button"
                        title="Settings"
                    />
                    <apck-button
                        icon="fa-regular fa-refresh"
                        :handler="refresh"
                        class="title-button"
                        title="Refresh"
                    />
                    <apck-button
                        :icon="['fa-regular', collapsed ? 'fa-chevron-down' : 'fa-chevron-up'].join(' ')"
                        :handler="collapse"
                        class="title-button"
                        :title="collapsed ? 'expand' : 'collapse'"
                    />
                    <apck-button
                        icon="fa-regular fa-close"
                        :handler="remove"
                        class="title-button"
                        title="Delete"
                    />
                </template>
                
                <div v-if="!collapsed" style="height: 300px; padding-bottom: 10px">
                    <apexchart
                        ref="portletChart"
                        :type="chartType"
                        :options="chartOptions"
                        :series="chartSeries"
                        :height="chartHeight"
                    />
                </div>
            </apck-panel>
        </div>
    `
});

